<div class="modal-popup">
  <div class="popup-heading">
    <h2 style="color: #0D87C8">
      {{ Edit ? 'Edit ' : (isViewMode ? 'View ' : 'Add ') }}
      {{ locationType }}
    </h2>
    
  </div>

  <form [formGroup]="locationForm" (ngSubmit)="onFormSubmit()">
    <div *ngFor="let heading of headings" class="field">
      <p class="label">{{ heading.name }}<span class="text-danger">*</span></p>
      
      <mat-form-field appearance="outline" class="fields-input">
        <ng-container *ngIf="locationType === 'Position' && heading.property === 'accountType' || locationType === 'Speciality' && heading.property === 'accountsTypes' || locationType === 'Account Type' && heading.name === 'Account Category' && heading.property === 'accountCategory'; else defaultInput">
          <mat-select *ngIf="this.locationType !== 'Account Type'" placeholder="Select" [formControlName]="heading.property" multiple>
            <mat-option *ngFor="let accountType of accountTypes" [value]="accountType">{{ accountType }}</mat-option>
          </mat-select>
          <mat-select *ngIf="this.locationType === 'Account Type'" placeholder="Select" [formControlName]="heading.property">
            <mat-option *ngFor="let accountType of accountTypes" [value]="accountType">{{ accountType }}</mat-option>
          </mat-select>
        </ng-container>

        <ng-template #defaultInput>
          <input matInput [formControlName]="heading.property" placeholder="Enter {{ heading.name }}"  (keypress)="heading.property === 'phoneCode' ? allowOnlyNumbersAndSpecialCharacters($event) : null">
        </ng-template>
        <mat-error *ngIf="locationForm.get(heading.property)!.hasError('required')">
         <img class="error-icon" loading="eager" alt="" src="./../../assets/images/alert.svg" /> {{ heading.name }} is required
        </mat-error>
      </mat-form-field>
      <div *ngIf="locationType === 'Equipment' || locationType === 'Speciality' && heading.property === 'accountsTypes' || locationType === 'Service' || locationType === 'Tests'" class="upload-container mt-1" [class.active]="isViewMode">
        <div>
          <mat-label class="label">{{(isViewMode)?'Image':'Upload Image'}}</mat-label> 
        </div>
        <mat-card class="upload-card" >
          <div class="upload-area" (click)="fileInput.click()" *ngIf="!imageUrl">
            <label class="d-flex justify-content-center text" for="upload" mat-raised-button>
              <img class="d-flex flex-row align-items-center justify-content-center " alt="" src="./../../assets/images/photo-add.svg"> <span style="color: #0D87C8 " class="d-flex flex-row align-items-center justify-content-center gap-1"> Select File</span> 
            </label>
          </div>
          <input #fileInput type="file" accept="image/*" (change)="selectFile($event)" style="display: none;" >
          <div *ngIf="imageUrl">
            <div class="file-item">
              <div class="file-details">
                <img [src]="this.locationForm?.get('imageUrl')?.value" class="file-thumbnail" alt="">
                <div class="file-info" >
                  <span>{{fileName}}</span>
                </div>
              </div>
              <button mat-icon-button color="warn" *ngIf="!isViewMode" (click)="deleteFile()">
                <mat-icon >close</mat-icon>
              </button>
            </div>
          </div>
        </mat-card>
        <mat-error class="error-message image-error" *ngIf="fileError">
          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Image is Required
        </mat-error>
        <mat-error class="error-message image-error" *ngIf="invalidFileType">
          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Invalid file type {{fileType}}, Only image files are allowed.
        </mat-error>
      </div>
    
<div *ngIf="locationType === 'incoterms'" class="incoterms-fields-container"> 
      <div formArrayName="fields">
        <div *ngFor="let field of fields.controls; let i = index" class="field-row" [formGroupName]="i">
          <div class="field">
            <p class="label">Label<span class="text-danger">*</span></p>
            <mat-form-field appearance="outline" class="fields-input">
              <input matInput placeholder="Enter Label" formControlName="label">
              <mat-error *ngIf="field.get('label')?.hasError('required')">
                <img class="error-icon" loading="eager" alt="" src="./../../assets/images/alert.svg" /> Label is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="field">
            <p class="label">Data Type<span class="text-danger">*</span></p>
            <mat-form-field appearance="outline" class="fields-input">
              <mat-select placeholder="Select Data Type" formControlName="dataType">
                <mat-option value="String">String</mat-option>
                <mat-option value="Number">Number</mat-option>
                <mat-option value="Date">Date</mat-option>
                <mat-option value="Boolean">Boolean</mat-option>
                <mat-option value="List">List</mat-option>
              </mat-select>
              <mat-error *ngIf="field.get('dataType')?.hasError('required')">
                <img class="error-icon" loading="eager" alt="" src="./../../assets/images/alert.svg" /> Data Type is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="field" *ngIf="field.get('dataType')?.value === 'List'">
            <p class="label">List Options<span class="text-danger">*</span></p>
            <mat-form-field appearance="outline" class="fields-input">
              <input matInput placeholder="Enter comma-separated options" formControlName="listOptions">
              <mat-hint *ngIf="!isViewMode">Example: Option1, Option2, Option3</mat-hint>
              <mat-error *ngIf="field.get('listOptions')?.hasError('required')">
                <img class="error-icon" loading="eager" alt="" src="./../../assets/images/alert.svg" /> List options are required
              </mat-error>
            </mat-form-field>
          </div>

          <button  mat-icon-button color="warn" type="button" *ngIf="fields.length > 1 && !isViewMode" (click)="removeField(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <button mat-raised-button color="primary" type="button" class="add-field-btn" (click)="addField()" *ngIf="!isViewMode">
        <mat-icon>add</mat-icon> Add Field
      </button>
    </div>
    </div>

    <div class="popup-buttons">
      <button mat-raised-button class="save-btn" type="submit" *ngIf="!isViewMode">Save</button>
      <button mat-raised-button class="cancel-btn" [mat-dialog-close]="false" type="button">Cancel</button>
    </div>
  </form>
</div>
